import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "inline-flex"
}
const _hoisted_2 = ["href"]
const _hoisted_3 = ["href"]
const _hoisted_4 = ["href"]
const _hoisted_5 = ["href"]
const _hoisted_6 = ["href"]
const _hoisted_7 = ["href"]

import {
  PhFacebookLogo,
  PhInstagramLogo,
  PhLinkedinLogo,
  PhTiktokLogo,
  PhXLogo,
  PhYoutubeLogo,
} from '@phosphor-icons/vue';
import {
  useStore,
} from '@/store';


export default /*#__PURE__*/_defineComponent({
  __name: 'SocialLink',
  setup(__props) {


const {
  facebook,
  instagram,
  youtube,
  linkedin,
  x,
  tiktok,
} = useStore.backend.clientCompany.socialLink;

const hasSocialLink = Object.values(useStore.backend.clientCompany.socialLink).find((s) => s.length > 0);


return (_ctx: any,_cache: any) => {
  return (_unref(hasSocialLink))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_unref(facebook))
          ? (_openBlock(), _createElementBlock("a", {
              key: 0,
              class: "mr-2 sm:mr-4",
              target: "_blank",
              rel: "noopener noreferrer",
              href: _unref(facebook)
            }, [
              _createVNode(_unref(PhFacebookLogo), { class: "size-4 hover:fill-yellow-2 sm:h-6 sm:w-6" })
            ], 8, _hoisted_2))
          : _createCommentVNode("", true),
        (_unref(instagram))
          ? (_openBlock(), _createElementBlock("a", {
              key: 1,
              class: "mr-2 sm:mr-4",
              target: "_blank",
              rel: "noopener noreferrer",
              href: _unref(instagram)
            }, [
              _createVNode(_unref(PhInstagramLogo), { class: "size-4 hover:fill-yellow-2 sm:h-6 sm:w-6" })
            ], 8, _hoisted_3))
          : _createCommentVNode("", true),
        (_unref(youtube))
          ? (_openBlock(), _createElementBlock("a", {
              key: 2,
              class: "mr-2 sm:mr-4",
              target: "_blank",
              rel: "noopener noreferrer",
              href: _unref(youtube)
            }, [
              _createVNode(_unref(PhYoutubeLogo), { class: "size-4 hover:fill-yellow-2 sm:h-6 sm:w-6" })
            ], 8, _hoisted_4))
          : _createCommentVNode("", true),
        (_unref(linkedin))
          ? (_openBlock(), _createElementBlock("a", {
              key: 3,
              class: "mr-2 sm:mr-4",
              target: "_blank",
              rel: "noopener noreferrer",
              href: _unref(linkedin)
            }, [
              _createVNode(_unref(PhLinkedinLogo), { class: "size-4 hover:fill-yellow-2 sm:h-6 sm:w-6" })
            ], 8, _hoisted_5))
          : _createCommentVNode("", true),
        (_unref(x))
          ? (_openBlock(), _createElementBlock("a", {
              key: 4,
              class: "mr-2 sm:mr-4",
              target: "_blank",
              rel: "noopener noreferrer",
              href: _unref(x)
            }, [
              _createVNode(_unref(PhXLogo), { class: "size-4 hover:fill-yellow-2 sm:h-6 sm:w-6" })
            ], 8, _hoisted_6))
          : _createCommentVNode("", true),
        (_unref(tiktok))
          ? (_openBlock(), _createElementBlock("a", {
              key: 5,
              target: "_blank",
              rel: "noopener noreferrer",
              href: _unref(tiktok)
            }, [
              _createVNode(_unref(PhTiktokLogo), { class: "size-4 hover:fill-yellow-2 sm:h-6 sm:w-6" })
            ], 8, _hoisted_7))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}
}

})